import { DateTime } from 'luxon';

export const DATETIME_FORMAT = 'dd MMM yyyy HH:mm:ss';
export const DATE_FORMAT = 'dd MMM yyyy';
export const DATE_ISO_FORMAT = 'yyyy-MM-dd';
export const NOW = DateTime.now().toFormat(DATE_ISO_FORMAT);
export const YESTERDAY = DateTime.now().minus({ days: 1 }).toFormat(DATE_ISO_FORMAT);
export const MONTH_START = DateTime.now().startOf('month').toFormat(DATE_ISO_FORMAT);

export const MONTH_OPTIONS = [
    { value: 0, label: 'January' },
    { value: 1, label: 'February' },
    { value: 2, label: 'March' },
    { value: 3, label: 'April' },
    { value: 4, label: 'May' },
    { value: 5, label: 'June' },
    { value: 6, label: 'July' },
    { value: 7, label: 'August' },
    { value: 8, label: 'September' },
    { value: 9, label: 'October' },
    { value: 10, label: 'November' },
    { value: 11, label: 'December' },
];

export const UNKNOWN = 'Unknown';
